import 'stylesheets/application'
import 'bootstrap/dist/js/bootstrap'

import Rails from '@rails/ujs'
import * as ActiveStorage from "@rails/activestorage"

import autosize from 'autosize'
import ClipboardJS from 'clipboard'
import jQuery from 'jquery'
import 'jquery.easing'
import toastr from 'toastr'

Rails.start()
ActiveStorage.start()

window.$ = jQuery

document.addEventListener('DOMContentLoaded', e => {
  import('startbootstrap-sb-admin/js/sb-admin')

  autosize(document.querySelectorAll('textarea'))

  const clipboard = new ClipboardJS('[data-clipboard-text]')
  clipboard.on('success', e => {
    toastr.success('コピーしました', '', { timeOut: 1000 })
  })

  document.querySelectorAll('.toastr-success').forEach(element => {
    toastr.success(element.innerHTML)
    element.classList.add('d-none')
  })
  document.querySelectorAll('.toastr-warning').forEach(element => {
    toastr.warning(element.innerHTML)
    element.classList.add('d-none')
  })

  jQuery('[data-toggle="tooltip"]').tooltip()
})
